import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { ConfirmLogoutDialogComponent } from '../../common/confirm.component';
import { Router } from '@angular/router';
import { LOGIN } from '../../constant/absolute-routes';
import { UtilitySerice } from '../../shared/services/utility.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MatIcon, MatTooltipModule, MatButtonModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  name: string = '';
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private _utilityService = inject(UtilitySerice);

  constructor() {
    this.name = this._utilityService.getLocalStorage('survey_admin_name') || '';
  }

  logout() {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    const dialogRef = this.dialog.open(ConfirmLogoutDialogComponent, {
      restoreFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        localStorage.removeItem('survey_admin_token');  
        localStorage.removeItem('survey_admin_name'); 
        localStorage.removeItem('survey_admin_id'); 
        this.router.navigate([LOGIN]);
      }
    });
  }
}
